var _desc, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuBackOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "download-w") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    transform: "rotate(90,12,12)",
    style: {
      fillRule: "evenodd",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "download-w"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m12 0c-6.6333 0-12 5.3667-12 12 0 6.6333 5.3667 12 12 12 6.6333 0 12-5.3667 12-12 0-6.6333-5.3667-12-12-12"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m16.485 16.587-3.6028 2.767c-0.08647 0.05765-0.17294 0.11529-0.2594 0.14411h-0.02882c-0.17294 0.08647-0.3747 0.14411-0.57646 0.14411-0.2594 0-0.54763-0.08647-0.77822-0.2594l-3.7181-2.7958c-0.57646-0.43234-0.69175-1.2394-0.2594-1.8158 0.43234-0.57646 1.2394-0.69175 1.8158-0.2594l1.6141 1.2106-0.02882-9.425c-3e-6 -0.72057 0.57645-1.297 1.297-1.297 0.72057 0 1.297 0.57646 1.297 1.297l0.02882 9.4539 1.6141-1.2394c0.57646-0.43234 1.3835-0.31705 1.8158 0.23058 0.46116 0.57646 0.34587 1.4123-0.23058 1.8447",
    style: {
      fill: "#009846"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBackOver);
export default __webpack_public_path__ + "static/media/menu-back-over.01d5e493d81dd9f576ae210f923d4dc5.svg";
export { ForwardRef as ReactComponent };